/**
 * @generated SignedSource<<ae1cf26762bbbacbe37444182e9f5508>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskMigrateDialog_task$data = {
  readonly course: {
    readonly id: string;
    readonly year: number;
  } | null;
  readonly id: string;
  readonly publishedUnitDs: ReadonlyArray<{
    readonly description: string | null;
    readonly id: string;
    readonly nextUnitD: {
      readonly description: string | null;
      readonly id: string;
    } | null;
    readonly previousUnitD: {
      readonly description: string | null;
      readonly id: string;
    } | null;
  }>;
  readonly " $fragmentType": "TaskMigrateDialog_task";
};
export type TaskMigrateDialog_task$key = {
  readonly " $data"?: TaskMigrateDialog_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskMigrateDialog_task">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskMigrateDialog_task",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "course",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "year",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "order",
          "value": {
            "order": "DESC"
          }
        }
      ],
      "concreteType": "UnitD",
      "kind": "LinkedField",
      "name": "publishedUnitDs",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "UnitD",
          "kind": "LinkedField",
          "name": "nextUnitD",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UnitD",
          "kind": "LinkedField",
          "name": "previousUnitD",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "publishedUnitDs(order:{\"order\":\"DESC\"})"
    }
  ],
  "type": "Task",
  "abstractKey": null
};
})();

(node as any).hash = "42a66aff989b5c7739afe4e6ae66e30c";

export default node;
